// The lenis instance, shared so navigation can reset the scroll position.
//
// This matters because lenis owns the scroll: it keeps its own position and
// applies it every frame. A plain window.scrollTo(0, 0) can be overwritten on the
// next frame, so route changes have to tell lenis itself to go to the top.
let instance = null;

export const registerLenis = (lenis) => {
    instance = lenis;
};

export const unregisterLenis = () => {
    instance = null;
};

// Jump to the top with no animation — used when the route changes, where easing
// the scroll would look like the new page slid in from its middle.
export const scrollToTop = () => {
    if (instance) {
        instance.scrollTo(0, { immediate: true, force: true });
        return;
    }
    // Before lenis mounts, or if smooth scrolling is ever removed.
    window.scrollTo(0, 0);
};

export const scrollToElement = (target, { offset = 0, immediate = false, duration = 1.2 } = {}) => {
    if (!target) return;

    if (instance) {
        instance.resize();
        instance.scrollTo(target, { offset: -offset, immediate, duration, force: true });
        return;
    }
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: immediate ? "auto" : "smooth" });
};
